import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "../scss/_products.scss";

const Products = () => {
  // Statische Produktdaten
  /* code for products */
  const products = [
    {
      id: 1,
      thumbnail: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-1.webp",
      image: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-1.webp",
      bgImage: "/images/siteBackground.jpg",
      title: "Hoodie",
      quantity: 10,
      link: "https://www.hanszimmerlive.com/tour",
    },
    {
      id: 2,
      thumbnail: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-2.webp",
      image: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-2.webp",
      bgImage: "/images/siteBackground.jpg",
      title: "Tickets for Hans Zimmer Live - The Next Level 2025 / 2026",
      quantity: 10,
      link: "https://www.hanszimmerlive.com/tour",
    },
    {
      id: 3,
      thumbnail: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-3.webp",
      image: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-3.webp",
      bgImage: "/images/siteBackground.jpg",
      title: "Tickets for Hans Zimmer Live - The Next Level 2025 / 2026",
      quantity: 10,
      link: "https://www.hanszimmerlive.com/tour",
    },
    {
      id: 4,
      thumbnail: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-4.webp",
      image: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-4.webp",
      bgImage: "/images/siteBackground.jpg",
      title: "Tickets for Hans Zimmer Live - The Next Level 2025 / 2026",
      quantity: 10,
      link: "https://www.hanszimmerlive.com/tour",
    },
    {
      id: 5,
      thumbnail: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-5.webp",
      image: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-5.webp",
      bgImage: "/images/siteBackground.jpg",
      title: "Tickets for Hans Zimmer Live - The Next Level 2025 / 2026",
      quantity: 10,
      link: "https://www.hanszimmerlive.com/tour",
    },
    {
      id: 6,
      thumbnail: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-6.webp",
      image: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-6.webp",
      bgImage: "/images/siteBackground.jpg",
      title: "Tickets for Hans Zimmer Live - The Next Level 2025 / 2026",
      quantity: 10,
      link: "https://www.hanszimmerlive.com/tour",
    },
    {
      id: 7,
      thumbnail: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-7.webp",
      image: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-7.webp",
      bgImage: "/images/siteBackground.jpg",
      title: "Tickets for Hans Zimmer Live - The Next Level 2025 / 2026",
      quantity: 10,
      link: "https://www.hanszimmerlive.com/tour",
    },
    {
      id: 8,
      thumbnail: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-8.webp",
      image: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-8.webp",
      bgImage: "/images/siteBackground.jpg",
      title: "Tickets for Hans Zimmer Live - The Next Level 2025 / 2026",
      quantity: 10,
      link: "https://www.hanszimmerlive.com/tour",
    },
    {
      id: 9,
      thumbnail: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-9.webp",
      image: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-9.webp",
      bgImage: "/images/siteBackground.jpg",
      title: "Tickets for Hans Zimmer Live - The Next Level 2025 / 2026",
      quantity: 10,
      link: "https://www.hanszimmerlive.com/tour",
    },
    {
      id: 10,
      thumbnail: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-10.webp",
      image: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-10.webp",
      bgImage: "/images/siteBackground.jpg",
      title: "Tickets for Hans Zimmer Live - The Next Level 2025 / 2026",
      quantity: 10,
      link: "https://www.hanszimmerlive.com/tour",
    },
    {
      id: 11,
      thumbnail: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-11.webp",
      image: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-11.webp",
      bgImage: "/images/siteBackground.jpg",
      title: "Tickets for Hans Zimmer Live - The Next Level 2025 / 2026",
      quantity: 10,
      link: "https://www.hanszimmerlive.com/tour",
    },
    {
      id: 17,
      thumbnail: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-17.webp",
      image: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-17.webp",
      bgImage: "/images/siteBackground.jpg",
      title: "Tickets for Hans Zimmer Live - The Next Level 2025 / 2026",
      quantity: 10,
      link: "https://www.hanszimmerlive.com/tour",
    },
    {
      id: 18,
      thumbnail: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-18.webp",
      image: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-18.webp",
      bgImage: "/images/siteBackground.jpg",
      title: "Tickets for Hans Zimmer Live - The Next Level 2025 / 2026",
      quantity: 10,
      link: "https://www.hanszimmerlive.com/tour",
    },
    {
      id: 19,
      thumbnail: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-19.webp",
      image: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-19.webp",
      bgImage: "/images/siteBackground.jpg",
      title: "Tickets for Hans Zimmer Live - The Next Level 2025 / 2026",
      quantity: 10,
      link: "https://www.hanszimmerlive.com/tour",
    },
    {
      id: 20,
      thumbnail: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-20.webp",
      image: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-20.webp",
      bgImage: "/images/siteBackground.jpg",
      title: "Tickets for Hans Zimmer Live - The Next Level 2025 / 2026",
      quantity: 10,
      link: "https://www.hanszimmerlive.com/tour",
    },
    {
      id: 21,
      thumbnail: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-21.webp",
      image: "/images/merch/250909-Hans-Zimmer-Live-Ideas-from-MFL-21.webp",
      bgImage: "/images/siteBackground.jpg",
      title: "Tickets for Hans Zimmer Live - The Next Level 2025 / 2026",
      quantity: 10,
      link: "https://www.hanszimmerlive.com/tour",
    },
  ];
  /* code for products */

  // Slider-Einstellungen
  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
          variableWidth: true,
          dots: true
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          variableWidth: true,
          dots: true
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          variableWidth: true,
          dots: true
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          variableWidth: true,
          dots: false,
          centerMode: true,
          centerPadding: '60px',
        },
      },
    ]
  };

  return (
    <section className="products" id="prices">
      <h2>What can you win?</h2>

      {/* React Slick Slider für Multiple Items */}
      <div className="products-slider products-slider--min-width">
        <Slider {...sliderSettings}>
          {products.map((product) => (
            <div key={product.id} className="slider-item">
              <div
                className="card"
                style={{
                  backgroundImage: `url(${product.bgImage})`,
                }}
              >
                <img
                  className="card--image"
                  src={product.thumbnail}
                  alt={product.title}
                />
                {/* <div className="card--inner">
                  <h3>{product.title}</h3>
                </div> */}
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default Products;
